import React from "react";
import PopularSOPCard from "./PopularSOPCard";
import {
  EnvelopeIcon,
  BuildingOffice2Icon,
  AcademicCapIcon,
  ArrowDownCircleIcon,
  MapIcon,
  ChatBubbleLeftEllipsisIcon,
  MagnifyingGlassCircleIcon,
  PencilSquareIcon,
} from "@heroicons/react/24/outline";
import Link from "next/link";
import { useRouter } from "next/router";
import { usePlausible } from "next-plausible";

const SOPs = [
  {
    Name: "Statement of Purpose",
    Icon: AcademicCapIcon,
    Type: "Student Visa",
    Description:
      "Unlock global opportunities with a student visa in your pocket!",
    ColorDark: "tootler-primary-400",
    ColorLight: "tootler-primary-300",
  },
  {
    Name: "GTE",
    Icon: AcademicCapIcon,
    Type: "GTE",
    Description:
      "Unlock global opportunities with a student visa in your pocket!",
    ColorDark: "tootler-primary-400",
    ColorLight: "tootler-primary-300",
  },
  {
    Name: "Statement of Purpose",
    Icon: MapIcon,
    Type: "Tourist Visa",
    Description:
      "Unlock Your Next Adventure with Our Hassle-Free Tourist Visa!",
    ColorDark: "tootler-primary-400",
    ColorLight: "tootler-primary-300",
  },
  {
    Name: "Statement of Purpose",
    Icon: BuildingOffice2Icon,
    Type: "University Application",
    Description:
      "Unlock Your Global Potential: Embark on an Educational Odyssey Abroad!",
    ColorDark: "tootler-primary-400",
    ColorLight: "tootler-primary-300",
  },
  {
    Name: "Letter of Recommendation",
    Icon: EnvelopeIcon,
    Type: "Letter of Recommendation",
    Description:
      "A LOR is one of the documents required when applying for universities or scholarships overseas",
    ColorDark: "red-500",
    ColorLight: "red-300",
  },
  /* {
    Name: "Sop Reviewer",
    Icon: MagnifyingGlassCircleIcon,
    Type: "Sop Reviewer",
    Description: "",
    ColorDark: "red-500",
    ColorLight: "red-300",
  }, */
  {
    Name: "Rejection Letter",
    Icon: PencilSquareIcon,
    Type: "Rejection Letter",
    Description:
      "The letter of rejection states why your application to a certain program was not successful.",
    ColorDark: "red-500",
    ColorLight: "red-300",
  },
  {
    Name: "Canadian Consultant Chatbot",
    Icon: ChatBubbleLeftEllipsisIcon,
    Type: "Canadian Consultant",
    Description:
      "The primary job of an immigration consultant is to assist people who want to immigrate.",
    ColorDark: "red-500",
    ColorLight: "red-300",
  },
];

const Step1 = () => {
  const router = useRouter();
  const { sopId } = router.query;
  const plausible = usePlausible();
  const handleClick = (buttonId: any) => {
    try {
      plausible(buttonId);
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <main className="max-w-7xl mx-auto py-20 px-4 ">
      <div className="flex flex-col text-center space-y-2 mb-10 lg:mb-20">
        <h2 className="text-tootler-grey-600 text-base lg:text-lg">
          Please Choose your
        </h2>
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-tootler-primary-900 mb-6">
          Generation Outline
        </h1>
      </div>
      <div className="mx-auto relative grid grid-cols-1 sm:grid-cols-2 w-fit lg:grid-cols-3 gap-10 md:mt-6">
        {SOPs.map((sop, index) => (
          <PopularSOPCard
            key={index}
            Name={sop.Name}
            Icon={<sop.Icon className="w-12 h-12 text-center mx-auto" />}
            Description={sop.Description}
            Type={sop.Type}
            check={""}
          />
        ))}
      </div>
    </main>
  );
};

export default Step1;
